module.exports = __webpack_public_path__ + "static/media/logo_80_kt.6babc6b0.png";